
<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
          <h3 class="box-title" style="text-transform: capitalize;">Đăng Ký Đậu Xe Tháng</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-4 mb-10" v-for="(vehicle, index) in vehicles" :key="index" @click="onOpenEditVehicleInput(vehicle)">
            <div class="description-item">
              <div class="row">
                <div class="col-md-12" style="text-align: right;">
                  <button type="button" class="btn bg-teal btn-sm" data-widget="remove" @click.stop="onOpenDeleteVehicle(vehicle)"><i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <h3 class="text-center">{{vehicle.manufacturer}}&nbsp;</h3>
                  <p class="text-muted text-center">{{vehicle.brand}}&nbsp;</p>
                </div>
                <div class="col-md-12 text-center">
                  <i class="fa fa-fw fa-motorcycle" :style="{color: vehicle.color_html_code, fontSize: `100px`, background: vehicle.color=='white' ? 'black' : 'white' }" v-if="vehicle.vehicle_type=='bike'"></i>
                  <i class="fa fa-fw fa-car" :style="{color: vehicle.color_html_code, fontSize: `100px`, background: vehicle.color=='white' ? 'black' : 'white' }" v-else></i>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="description-block border-right">
                    <span class="text-yellow">{{$t(`vehicle.plate_no`)}}</span>
                    <h5 class="description-header">{{vehicle.plate_no}}&nbsp;</h5>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="description-block border-right">
                    <span class="text-yellow">{{$t(`vehicle.register_date`)}}</span>
                    <h5 class="description-header">{{vehicle.register_date}}&nbsp;</h5>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="description-block border-right">
                    <span class="text-yellow">{{$t(`vehicle.color`)}}</span>
                    <h5 class="description-header">{{$t(`common.color.${vehicle.color}`)}}&nbsp;</h5>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="description-block border-right owner-block">
                    <span class="text-blue">{{$t(`vehicle.vehicle_owner`)}}</span>
                    <h5 class="description-header">{{vehicle.vehicle_owner}}&nbsp;</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="description-item new-item" @click="onOpenAddVehicleInput">
              <div class="row" style="visibility: hidden;">
                <div class="col-md-12" style="text-align: right;">
                  <button type="button" class="btn bg-teal btn-sm" data-widget="remove"><i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <h3 class="text-center">&nbsp;</h3>
                  <p class="text-muted text-center">&nbsp;</p>
                </div>
                <div class="col-md-12 text-center">
                  <i class="fa fa-fw fa-plus" style="font-size: 100px;"></i>
                </div>
              </div>
              <div class="row" style="visibility: hidden;">
                <div class="col-md-4">
                  <div class="description-block border-right">
                    <span class="text-yellow">&nbsp;</span>
                    <h5 class="description-header">&nbsp;</h5>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="description-block border-right">
                    <span class="text-yellow">&nbsp;</span>
                    <h5 class="description-header">&nbsp;</h5>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="description-block border-right">
                    <span class="text-yellow">&nbsp;</span>
                    <h5 class="description-header">&nbsp;</h5>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="description-block border-right owner-block">
                    <span class="text-blue">&nbsp;</span>
                    <h5 class="description-header">&nbsp;</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="box-footer">
      </div>
    </div>
    <!-- Modal Relative Input -->
    <div class="modal fade" :ref="`modal-customer-vehicle-input`">
      <div class="modal-dialog modal-lg">
        <RegisterVehicleInputView
          :id="vehicle_data.id"
          @vehicle-add="onAddVehicle"
          @vehicle-save="onSaveVehicle"
        />
      </div>
    </div>
    <!-- Modal Confirm Delete -->
    <div class="modal fade" :ref="`modal-customer-vehicle-delete`">
      <div class="modal-dialog">
        <Confirm
          :id="vehicle_data.id"
          @confirm="onDeleteVehicle"
        />
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import RegisterVehicleInputView from './RegisterVehicleInputView'
import Confirm from "@/components/Confirm.vue"
import utils from '@/lib/utils'

export default {
  name: "RegisterVehicleView",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      vehicles: [],
      vehicle_data: {
        id: 0
      }
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.getVehiclesList()
      } else {
        // pass
      }
    },
    VEHICLE_LIST: function() {
      let vehicles = []
      this.VEHICLE_LIST.forEach(vehicle => {
        let id = vehicle.id
        let manufacturer = vehicle.manufacturer_details.name
        let brand = vehicle.brand
        let plate_no = vehicle.plate_no
        let vehicle_owner = vehicle.parking_details.owner_full_name
        let color = vehicle.color_details.name
        let color_html_code = vehicle.color_details.html_code
        let vehicle_type = vehicle.vehicle_type_details.name
        let register_date = vehicle.parking_details ? utils.formatSqlDate(vehicle.parking_details.register_date, null, this.dateViewOptions) : null
        let item = {
          id: id,
          manufacturer: manufacturer,
          brand: brand,
          plate_no: plate_no,
          vehicle_owner: vehicle_owner,
          color: color,
          color_html_code: color_html_code,
          vehicle_type: vehicle_type,
          register_date: register_date
        }
        vehicles.push(item)
      })
      this.vehicles = vehicles
      this.$emit('vehicles', this.vehicles)
    }
  },
  computed: {
    ...mapGetters([
      "VEHICLE_LIST"
    ]),
    dateViewOptions: function(){
      return sessionStorage.getItem('projectDateViewOptions')
    },
  },
  methods: {
    ...mapActions([
      "GET_VEHICLE_LIST",
      "ADD_VEHICLE",
      "UPDATE_VEHICLE",
      "DELETE_VEHICLE"
    ]),
    getVehiclesList: function(data){
      if (this.id == 0){ return }
      const payload = {
        params: {
          user: this.id
        }
      }
      this.GET_VEHICLE_LIST(payload)
    },
    onToggleModalInput: function(action="show") {
      $(this.$refs[`modal-customer-vehicle-input`]).modal(action)
    },
    onToggleDeleteConfirm: function(action="show") {
      $(this.$refs[`modal-customer-vehicle-delete`]).modal(action)
    },
    onAddVehicle: function(saveVehicle) {
      saveVehicle.parking.user = this.id
      const payload = {
        data: saveVehicle
      }
      this.ADD_VEHICLE(payload).then(
        function(res) {
          this.onToggleModalInput("hide")
          this.getVehiclesList()
        }.bind(this)
      )
    },
    onSaveVehicle: function(id, saveVehicle) {
      saveVehicle.parking.user = this.id
      const payload = {
        id: id,
        data: saveVehicle
      }
      this.UPDATE_VEHICLE(payload).then(
        function(res) {
          this.onToggleModalInput("hide")
          this.getVehiclesList()
        }.bind(this)
      )
    },
    onOpenAddVehicleInput: function() {
      this.vehicle_data.id = 0
      this.onToggleModalInput()
    },
    onOpenEditVehicleInput: function(vehicle) {
      this.vehicle_data.id = vehicle.id
      this.onToggleModalInput()
    },
    onOpenDeleteVehicle: function(vehicle) {
      this.vehicle_data.id = vehicle.id
      this.onToggleDeleteConfirm()
    },
    onDeleteVehicle: function(id) {
      const payload = {
        id: id
      }
      this.DELETE_VEHICLE(payload).then(
        function() {
          this.onToggleDeleteConfirm("hide")
          this.getVehiclesList()
        }.bind(this)
      )
    },
  },
  mounted() {
    this.getVehiclesList()
  },
  components: {
    RegisterVehicleInputView,
    Confirm
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.description-block {
  text-align: left;
}

.owner-block {
  background: antiquewhite;
  padding: 10px;
}

.description-item {
  padding: 10px;
  border-top: 3px solid #d2d6de;
  box-shadow: 0 1px 1px rgba(0,0,0,0.1);
  border-top-color: #50bc3c;
  cursor: pointer;
}

.new-item {
  background: lightgrey;
  border: 1px solid black;
  border-style: dashed;
}

.mb-10 {
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/Customer/RegisterVehicleView.vue